import {
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_SUBMITTED_EDIT_ONLY_ID,
} from '../constants/siteStatuses'

export function compareHistoriesByReassessmentThenDate(a, b) {
  if (a.reassessmentFlag === b.reassessmentFlag) {
    return new Date(b.createdAt) - new Date(a.createdAt)
  }
  return a.reassessmentFlag ? 1 : -1
}

export function sortSiteHistoriesInPlace(histories) {
  return histories.sort(compareHistoriesByReassessmentThenDate)
}

export function filterOutEditOnlyHistories(histories) {
  return histories.filter(
    (item) =>
      item.SiteStatusId !== SITE_STATUS_EDIT_ONLY_ID &&
      item.SiteStatusId !== SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  )
}
